<template>
  <form
      class="cms-news-search"
      @submit.prevent="onSubmit"
      @reset.prevent="onReset"
      role="search">

    <tabs-component v-if="allFilters.length > 1" 
                    :items="allFilters"
                    v-model="selectedFilterValue"
                    theme="light"
    />

    <InputControl
      v-model="queryString"
      size="min"
      class="cms-news-search__field"
      :placeholder="$res.Views.NewsList_SearchPlaceholder"
    >
      <template #end>
        <span v-if="queryString"
              @click="onReset"
              class="cms-news-search__input-icon">
          <svg-icon icon="clear" class="pointer"/>          
        </span>
          <span v-else class="cms-news-search__input-icon">
          <svg-icon icon="magnifier" viewBox="0 0 16 16"/>
        </span>
      </template>
    </InputControl>      
  </form>
</template>

<script>
import Base from "./CmsNewsSearchFormBase";
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import TabsComponent from "@/common/controls/TabsComponentDesktop.vue";
import InputControl from "@/common/controls/forms/input/InputControl.vue";

export default {
  extends: Base,
  components: {
    InputControl,
    TabsComponent,
    SvgIcon,
  },
}
</script>


<style lang="scss" scoped>
.cms-news-search {
  display: flex;
  justify-content: space-between;
  padding-block-start: 10px;
}

.cms-news-search__field {
  width: 440px;
}

.cms-news-search__input-icon {
  color: var(--main-10);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>